module.exports = __webpack_public_path__ + "static/media/icon_extension_mp4.4ad95fb2.svg";